import { list, request } from "@/lib/api/client";
import { useList } from "@/lib/api/queries";

/**
 * Buyurtmani aniq xodimga biriktirish.
 *
 * Odatda ish O'ZI taqsimlanadi: bo'sh xodim TSD da «Topshiriq
 * olish» ni bosganda server unga roliga mos eng ustuvor ishni
 * beradi. Shuning uchun bu maydon IXTIYORIY va sukut bo'yicha
 * bo'sh — majburiy qilinsa, dispetcher har bir buyurtma uchun
 * qaror qabul qilishga majbur bo'lardi va navbat o'zi ishlashdan
 * to'xtardi.
 *
 * Ilgari bu «Dispetcher» degan alohida bo'limda edi. Buyurtmani
 * ishga qo'yish va uni kimgadir berish BITTA qaror: ikki ekranga
 * bo'lingani uchun dispetcher buyurtmani chiqargandan keyin
 * boshqa bo'limga o'tib, o'sha ishni qaytadan izlashi kerak edi.
 */

interface Staff {
  user_id: string;
  username: string;
  full_name?: string;
  roles: string[];
  busy: boolean;
  assigned: number;
}

export function AssigneeField({
  warehouseCode,
  role,
  value,
  onChange,
  hint,
}: {
  warehouseCode: string;
  /** Qaysi roldagi xodimlar ko'rsatiladi (server ham shuni tekshiradi). */
  role: string;
  value: string;
  onChange: (value: string) => void;
  hint: string;
}) {
  const staff = useList<Staff>("task", "/api/v1/work-queues/staff", {
    warehouse_code: warehouseCode,
  });

  // Faqat kerakli roldagilar: boshqa roldagi xodimga biriktirish
  // serverda rad etiladi va dispetcher buni faqat bosgandan keyin
  // bilib olardi.
  const people = (staff.data?.items ?? [])
    .filter((person) => person.roles.includes(role))
    .sort(
      (left, right) =>
        Number(left.busy) - Number(right.busy) ||
        left.assigned - right.assigned ||
        (left.full_name ?? left.username).localeCompare(right.full_name ?? right.username),
    );

  return (
    <label className="field">
      <span className="field-label">Kim bajaradi</span>
      <select
        className="input"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={staff.isLoading}
      >
        <option value="">Avtomatik — bo'sh xodim o'zi oladi</option>
        {people.map((person) => (
          <option key={person.user_id} value={person.user_id}>
            {person.full_name || person.username}
            {person.busy ? " — band" : " — bo'sh"}
            {person.assigned > 0 ? ` (${person.assigned} ish)` : ""}
          </option>
        ))}
      </select>
      <span className="field-hint">
        {staff.error
          ? "Xodimlar ro'yxati o'qilmadi — ish avtomatik taqsimlanadi."
          : people.length === 0 && !staff.isLoading
            ? "Bu rolda xodim yo'q — ish navbatda turadi."
            : hint}
      </span>
    </label>
  );
}

interface Task {
  id: string;
  task_type: string;
  assignee_id?: string;
}

/**
 * Hujjatdan tug'ilgan topshiriqlarni xodimga biriktiradi.
 *
 * Hujjat ishga qo'yilgandan KEYIN chaqiriladi: topshiriqlar
 * o'shanda paydo bo'ladi. Bitta buyurtmadan bir nechta topshiriq
 * chiqishi mumkin (zona yoki marshrut bo'yicha) va ularning
 * hammasi bitta odamga beriladi — «bu buyurtmani falonchi teradi»
 * degani shu.
 *
 * Allaqachon biriktirilganiga TEGILMAYDI: qayta taqsimlashda
 * xodim o'z ishidan ayrilib qolardi.
 */
export async function assignOrderTasks(
  orderId: string,
  assigneeId: string,
  taskType: string,
): Promise<number> {
  const tasks = await list<Task>("task", "/api/v1/tasks", { order_id: orderId, limit: 100 });
  const targets = tasks.items.filter(
    (task) => task.task_type === taskType && !task.assignee_id,
  );

  let assigned = 0;
  for (const task of targets) {
    await request("task", `/api/v1/tasks/${task.id}/assign`, {
      method: "POST",
      body: { assignee_id: assigneeId },
    });
    assigned += 1;
  }
  return assigned;
}
